import { FC, ReactNode } from 'react';

import { Button } from 'src/general/components/Button/Button';
import { Image } from 'src/general/components/Image/Image';

import { getSigninUrl } from './ssoHelper';

const carmaAuthApi = `${process.env.REACT_APP_AUTH_BASE_API_URL}/auth/google`;

type Props = {
  redirectUrl?: string;
  label: ReactNode;
};

const getSSOUrl = (redirectUrl?: string): string | null => {
  const signinUrl = getSigninUrl(redirectUrl);
  const queryParams = new URLSearchParams({
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile openid',
    include_granted_scopes: 'true',
    enable_granular_consent: 'true',
    response_type: 'code',
    prompt: 'consent',
    state: btoa(signinUrl),
    redirect_uri: carmaAuthApi,
    client_id: process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID ?? '',
  });
  return `https://accounts.google.com/o/oauth2/v2/auth?${queryParams}`;
};

export const SSOGoogle: FC<Props> = ({ redirectUrl, label }) => {
  const ssoUrl = getSSOUrl(redirectUrl);

  if (!ssoUrl) {
    return null;
  }

  return (
    <Button href={ssoUrl ?? ''} target="_self" fullWidth variant="secondary" size="medium">
      <span className="flex items-center gap-2">
        <span className="-my-4 block">
          <Image src="/images/google.svg" width={24} height={24} alt="Google" />
        </span>
        {label}
      </span>
    </Button>
  );
};
